import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useNavigate, Link } from "react-router-dom";

import { API_BASE_URL, Image_URL } from "../config";

const Index = () => {
  const [sliders, setSliders] = useState([]);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [storedUser, setStoredUser] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  
  const navigate = useNavigate();

  // Check backend session on page load (Fixes cross-subdomain auto-login)
  useEffect(() => {
    checkSession();
    fetchSliderData();
    fetchProducts();
    fetchCategoryData();
  }, []);
  // Index.js me checkSession function ko aise update karein:
const checkSession = async () => {
  try {
    const res = await fetch(`${API_BASE_URL}/Home/GetProfile`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    const result = await res.json();
    
    // Check if user is actually authenticated
    
    if (result.success && result.data) {
      localStorage.setItem("user", JSON.stringify(result.data));
      setStoredUser(result.data);
    } else {
      // Agar backend bole session invalid hai, toh local storage Saaf karein
      localStorage.removeItem("user");
      setStoredUser(null);
    }
  } catch (err) {
    console.error("Session check failed:", err);
    localStorage.removeItem("user");
    setStoredUser(null);
  }
};

  const handleProtectedNavigation = (path) => {
    const isLoggedIn = !!localStorage.getItem("user") || !!storedUser;

    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate(path);
    }
  };

  const settings = {
    dots: sliders.length > 1,
    arrows: sliders.length > 1,
    infinite: sliders.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: sliders.length > 1,
    autoplaySpeed: 3000,
  };

  const fetchSliderData = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/Home/GetSlider`);
      const result = await response.json();
      if (result.success && result.data) {
        setSliders(result.data);
      } else {
        console.error("Failed to fetch slider data:", result.message);
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const fetchCategoryData = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/Menu/GetMenuSubmenu`);
      const result = await response.json();

      if (result.success && result.data) {
        const uniqueCategories = Array.from(
          new Map(result.data.map((item) => [item.CategoryId, item])).values()
        );
        setCategories(uniqueCategories);
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };

  const preferredOrder = [
    "Engagement Rings",
    "Wedding Rings",
    "Fashion Rings",
    "Earrings",
    "Pendants",
    "Bracelets",
  ];

  const sortedCategories = [...categories].sort(
    (a, b) =>
      preferredOrder.indexOf(a.CategoryName) -
      preferredOrder.indexOf(b.CategoryName)
  );

  const fetchProducts = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/Product/GetProductOnSite`);
      const result = await res.json();
      if (result.success) {
        setProducts(result.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getFirstImage = (image) => {
    if (!image) return "";
    return image.split(",")[0].trim();
  };

  const ProductSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 400,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, slidesToScroll: 1 },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "40px",
          arrows: true,
        },
      },
    ],
  };

  const categorySettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "40px",
          arrows: true,
        },
      },
    ],
  };

  return (
    <div className="home home-4 title-4">
      <div id="page" className="hfeed page-wrapper">
        <Header />
        <main id="site-main" className="site-main">
          <div id="main-content" className="main-content">
            <div id="primary" className="content-area">
              <div id="content" className="site-content" role="main">
                
                {/* Sliders Section */}
                <section className="section m-b-0">
                  <div className="block block-sliders layout-4 auto-height color-white nav-center">
                    {sliders.length > 0 && (
                      <Slider {...settings}>
                        {sliders.map((slider) => (
                          <div className="item" key={slider.id}>
                            <div className="item-content">
                              <div className="content-image">
                                <img
                                  src={`${Image_URL}SliderImages/${slider.image}`}
                                  alt={slider.title}
                                />
                              </div>
                              <div className="item-info horizontal-center vertical-middle text-center">
                                <div className="content">
                                  <div className="subtitle-slider">
                                    {slider.title}
                                  </div>
                                  <h2 className="title-slider">
                                    {slider.description}
                                  </h2>
                                  {(!storedUser ||
                                    Object.keys(storedUser).length === 0) && (
                                    <>
                                      <Link
                                        style={{ fontSize: 30, marginRight: "15px" }}
                                        className="button-slider button button-white button-outline thick-border"
                                        to="/login"
                                      >
                                        Login
                                      </Link>

                                      <Link
                                        style={{ fontSize: 30 }}
                                        className="button-slider button button-white button-outline thick-border"
                                        to="/registration"
                                      >
                                        Register
                                      </Link>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    )}
                  </div>
                </section>

                {/* Categories Section */}
                <section className="section section-padding background-img bg-img-2 p-t-70 p-b-50 m-b-70">
                  <div className="section-container">
                    <div className="block block-product-cats slider layout-3">
                      <div className="block-widget-wrap">
                        <div className="block-title">
                          <div className="sub-title">We’ve Got You Covered</div>
                          <h2>Explore the Range</h2>
                          <br />
                          {(!storedUser || Object.keys(storedUser).length === 0) && (
                            <label className="sub-title" style={{ fontSize: "16px" }}>
                              <Link to="/login" style={{ marginRight: "6px", fontWeight: "600" }}>
                                Login
                              </Link>
                              or
                              <Link to="/registration" style={{ marginLeft: "6px", fontWeight: "600" }}>
                                Register
                              </Link>{" "}
                              to view
                            </label>
                          )}
                        </div>
                        <div className="block-content">
                          <div className="product-cats-list slick-wrap">
                            <Slider {...categorySettings}>
                              {sortedCategories.map((item) => (
                                <div className="item item-product-cat" key={item.CategoryId}>
                                  <div className="item-product-cat-content">
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleProtectedNavigation(
                                          `/products?category=${encodeURIComponent(item.CategoryName)}`
                                        );
                                      }}
                                    >
                                      <div className="item-image animation-horizontal">
                                        <img
                                          style={{ width: 250, height: 315 }}
                                          src={`${Image_URL}MasterImg/${item.CategeImg}`}
                                          alt={item.CategoryName}
                                        />
                                      </div>
                                    </a>

                                    <div className="product-cat-content-info">
                                      <h2 className="item-title">
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleProtectedNavigation(
                                              `/products?category=${encodeURIComponent(item.CategoryName)}`
                                            );
                                          }}
                                        >
                                          {item.CategoryName}
                                        </a>
                                      </h2>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </Slider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Products Section */}
                <section className="section section-padding background-img bg-img-2 p-t-70 p-b-50 m-b-70">
                  <div className="section-container">
                    <div className="block block-product-cats slider layout-3">
                      <div className="block-widget-wrap">
                        <div className="block-title">
                          <div className="sub-title">We’ve Got You Covered</div>
                          <h2>Explore the Products</h2>
                          {(!storedUser || Object.keys(storedUser).length === 0) && (
                            <label className="sub-title" style={{ fontSize: "16px" }}>
                              <Link to="/login" style={{ marginRight: "6px", fontWeight: "600" }}>
                                Login
                              </Link>
                              or
                              <Link to="/registration" style={{ marginLeft: "6px", fontWeight: "600" }}>
                                Register
                              </Link>{" "}
                              to view
                            </label>
                          )}
                        </div>

                        <div className="block-content">
                          <div className="product-cats-list">
                            <Slider {...ProductSettings}>
                              {products.map((item) => {
                                const firstImage = getFirstImage(item.image);
                                return (
                                  <div className="item item-product-cat" key={item.id}>
                                    <div className="item-product-cat-content">
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleProtectedNavigation("/products");
                                        }}
                                      >
                                        <div className="item-image animation-horizontal">
                                          <img
                                            style={{ width: "100%", height: "auto" }}
                                            src={`${Image_URL}UatProduct/${firstImage}`}
                                            alt={item.productname}
                                          />
                                        </div>
                                      </a>

                                      <div className="product-cat-content-info">
                                        <h2 className="item-title">
                                          <a
                                            href="#"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleProtectedNavigation("/products");
                                            }}
                                          >
                                            View More
                                          </a>
                                        </h2>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </Slider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Banners Section */}
                <section className="section section-padding m-b-70">
                  <div className="section-container large">
                    <div className="block block-banners layout-4 banners-effect">
                      <div className="block-widget-wrap">
                        <div className="row">
                          <div className="col-md-6 sm-m-b-40">
                            <div className="block-widget-banner">
                              <div className="bg-banner">
                                <div className="banner-wrapper banners">
                                  <div className="banner-image">
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleProtectedNavigation("/products");
                                      }}
                                    >
                                      <img
                                        width="690"
                                        height="398"
                                        src="../assets/media/banner/banner-4-1.jpg"
                                        alt="Banner Image"
                                      />
                                    </a>
                                  </div>
                                  <div className="banner-wrapper-infor">
                                    <div className="info">
                                      <div className="content">
                                        <h3 className="title-banner">New Arrivals</h3>
                                        <div className="banner-image-description">
                                          Elevate your ear party with a choice of mix and matched stacks or striking solo statements. The choice is yours!
                                        </div>
                                        <a
                                          href="#"
                                          className="button button-outline border-black"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleProtectedNavigation("/products");
                                          }}
                                        >
                                          Login Or Register to view
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="block-widget-banner">
                              <div className="bg-banner">
                                <div className="banner-wrapper banners">
                                  <div className="banner-image">
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleProtectedNavigation("/products");
                                      }}
                                    >
                                      <img
                                        width="690"
                                        height="398"
                                        src="../assets/media/banner/banner-4-2.jpg"
                                        alt="Banner Image"
                                      />
                                    </a>
                                  </div>
                                  <div className="banner-wrapper-infor">
                                    <div className="info">
                                      <div className="content">
                                        <h3 className="title-banner">Trending</h3>
                                        <div className="banner-image-description">
                                          Love to layer? Us too! Transition your outfits from day to night in one easy step with the power of a unique, luxe layered look.
                                        </div>
                                        <a
                                          href="#"
                                          className="button button-outline border-black"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleProtectedNavigation("/products");
                                          }}
                                        >
                                          Login Or Register to view
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Index;


// import React, { useEffect, useState } from "react";
// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL, Image_URL } from "../config";

// const Index = () => {
//   const [sliders, setSliders] = useState([]);
//   const [products, setProducts] = useState([]);

//   const [categories, setCategories] = useState([]);
//   const navigate = useNavigate();
//   const storedUser = JSON.parse(localStorage.getItem("user"));
//   const handleProtectedNavigation = (path) => {
//     const isLoggedIn = !!localStorage.getItem("user");

//     if (!isLoggedIn) {
//       navigate("/login");
//     } else {
//       navigate(path);
//     }
//   };
//   useEffect(() => {
//     fetchSliderData();
//     fetchProducts();
//     fetchCategoryData();
//   }, []);
//   const settings = {
//     dots: sliders.length > 1,
//     arrows: sliders.length > 1,
//     infinite: sliders.length > 1, // ✅ KEY FIX
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: sliders.length > 1,
//     autoplaySpeed: 3000,
//   };

//   const fetchSliderData = async () => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/Home/GetSlider`);
//       const result = await response.json();
//       if (result.success && result.data) {
//         setSliders(result.data);
//       } else {
//         console.error("Failed to fetch slider data:", result.message);
//       }
//     } catch (error) {
//       console.error("Error fetching slider data:", error);
//     }
//   };
//   const fetchCategoryData = async () => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/Menu/GetMenuSubmenu`);
//       const result = await response.json();

//       if (result.success && result.data) {
//         // Remove duplicate categories
//         const uniqueCategories = Array.from(
//           new Map(result.data.map((item) => [item.CategoryId, item])).values(),
//         );

//         setCategories(uniqueCategories);
//       }
//     } catch (error) {
//       console.error("Error fetching category data:", error);
//     }
//   };

//   const preferredOrder = [
//     "Engagement Rings",
//     "Wedding Rings",
//     "Fashion Rings",
//     "Earrings",
//     "Pendants",
//     "Bracelets",
//   ];
//   const sortedCategories = [...categories].sort(
//     (a, b) =>
//       preferredOrder.indexOf(a.CategoryName) -
//       preferredOrder.indexOf(b.CategoryName),
//   );

//   const fetchProducts = async () => {
//     try {
//       const res = await fetch(`${API_BASE_URL}/Product/GetProductOnSite`);
//       const result = await res.json();
//       if (result.success) {
//         setProducts(result.data);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };
//   const getFirstImage = (image) => {
//     if (!image) return "";
//     return image.split(",")[0].trim();
//   };
//   const ProductSettings = {
//   dots: false,
//   arrows: true,
//   infinite: true, // Required for autoplay & centerMode peeking
//   autoplay: true,
//   autoplaySpeed: 3000,
//   speed: 400,
//   slidesToShow: 5, // Desktop layout
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1024, // Tablet breakpoint
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//       },
//     },
//     {
//       breakpoint: 768, // Mobile breakpoint
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         centerMode: true, // Centers 1 slide and peeks adjacent slides
//         centerPadding: "40px", // Controls how much of the next item shows
//         arrows: true, // Keeps nav buttons visible on mobile
//       },
//     },
//   ],
// };
//  const categorySettings = {
//   dots: false,
//   infinite: true,
//   speed: 500,
//   slidesToShow: 4, // Default for desktop
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 3000,
//   arrows: true, // Keep nav buttons enabled globally
//   responsive: [
//     {
//       breakpoint: 768, // Mobile breakpoint
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         centerMode: true, // Key property to reveal the next slide
//         centerPadding: "40px", // How much of the next slide shows on screen
//         arrows: true, // Ensure arrows remain visible on mobile
//       },
//     },
//   ],
// };

//   return (
//     <div className="home home-4 title-4">
//       <div id="page" className="hfeed page-wrapper">
//         <Header />
//         <main id="site-main" className="site-main">
//           <div id="main-content" className="main-content">
//             <div id="primary" className="content-area">
//               <div id="content" className="site-content" role="main">
//                 <section className="section m-b-0">
//                   <div className="block block-sliders layout-4 auto-height color-white nav-center">
//                     {sliders.length > 0 && (
//                       <Slider {...settings}>
//                         {sliders.map((slider) => (
//                           <div className="item" key={slider.id}>
//                             <div className="item-content">
//                               <div className="content-image">
//                                 <img
//                                   style={{}}
//                                   src={`${Image_URL}SliderImages/${slider.image}`}
//                                   alt={slider.title}
//                                 />
//                               </div>
//                               <div className="item-info horizontal-center vertical-middle text-center">
//                                 <div className="content">
//                                   <div className="subtitle-slider">
//                                     {slider.title}
//                                   </div>
//                                   <h2 className="title-slider">
//                                     {slider.description}
//                                   </h2>
//                                   {(!storedUser ||
//                                     Object.keys(storedUser).length === 0) && (
//                                     <>
//                                       <a
//                                         style={{
//                                           fontSize: 30,
//                                           marginRight: "15px",
//                                         }}
//                                         className="button-slider button button-white button-outline thick-border"
//                                         href="/login"
//                                         rel="noopener noreferrer"
//                                       >
//                                         Login
//                                       </a>

//                                       <a
//                                         style={{ fontSize: 30 }}
//                                         className="button-slider button button-white button-outline thick-border"
//                                         href="/registration"
//                                         rel="noopener noreferrer"
//                                       >
//                                         Register
//                                       </a>
//                                     </>
//                                   )}
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         ))}
//                       </Slider>
//                     )}
//                   </div>
//                 </section>
//                 <section className="section section-padding background-img bg-img-2 p-t-70 p-b-50 m-b-70">
//                   <div className="section-container">
//                     <div className="block block-product-cats slider layout-3">
//                       <div className="block-widget-wrap">
//                         <div className="block-title">
//                           <div className="sub-title">We’ve Got You Covered</div>
//                           <h2>Explore the Range</h2>
//                           <br></br>
//                           <label
//                             className="sub-title"
//                             style={{ fontSize: "16px" }}
//                           >
//                             <a
//                               href="/login"
//                               style={{ marginRight: "6px", fontWeight: "600" }}
//                             >
//                               Login
//                             </a>
//                             or
//                             <a
//                               href="/registration"
//                               style={{ marginLeft: "6px", fontWeight: "600" }}
//                             >
//                               Register
//                             </a>{" "}
//                             to view
//                           </label>
//                         </div>
//                         <div className="block-content">
//                           <div className="product-cats-list slick-wrap">
//                             <Slider {...categorySettings}>
//                               {sortedCategories.map((item) => (
//                                 <div
//                                   className="item item-product-cat"
//                                   key={item.CategoryId}
//                                 >
//                                   <div className="item-product-cat-content">
//                                     <a
//                                       href="#"
//                                       onClick={(e) => {
//                                         e.preventDefault();
//                                         handleProtectedNavigation(
//                                           `/products?category=${encodeURIComponent(item.CategoryName)}`,
//                                         );
//                                       }}
//                                     >
//                                       <div className="item-image animation-horizontal">
//                                         <img
//                                           style={{ width: 250, height: 315 }}
//                                           src={`${Image_URL}MasterImg/${item.CategeImg}`}
//                                           alt={item.CategoryName}
//                                         />
//                                       </div>
//                                     </a>

//                                     <div className="product-cat-content-info">
//                                       <h2 className="item-title">
//                                         <a
//                                           href="#"
//                                           onClick={(e) => {
//                                             e.preventDefault();
//                                             handleProtectedNavigation(
//                                               `/products?category=${encodeURIComponent(item.CategoryName)}`,
//                                             );
//                                           }}
//                                         >
//                                           {item.CategoryName}
//                                         </a>
//                                       </h2>
//                                     </div>
//                                   </div>
//                                 </div>
//                               ))}
//                             </Slider>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </section>
//                 {/* <div
//   style={{
//     width: "100%",
//     overflow: "hidden",
//     marginTop: "40px",
//     marginBottom: "40px"
//   }}
// ><video
//     autoPlay
//     loop
//     muted
//     playsInline
//     style={{
//       width: "100%",     
//       objectFit: "cover"
//     }}
//   >
//     <source src="../assets/media/AUCER4648.mp4" type="video/mp4" />
//   </video>
//   <video
//     autoPlay
//     loop
//     muted
//     playsInline
//     style={{
//       width: "100%",
//       maxHeight: "700px",
//       objectFit: "cover"
//     }}
//   >
//     <source src="../assets/media/AUCER4648.mp4" type="video/mp4" />
//   </video>
// </div> */}

//                 <section className="section section-padding background-img bg-img-2 p-t-70 p-b-50 m-b-70">
//                   <div className="section-container">
//                     <div className="block block-product-cats slider layout-3">
//                       <div className="block-widget-wrap">
//                         <div className="block-title">
//                           <div className="sub-title">We’ve Got You Covered</div>
//                           <h2>Explore the Products</h2>

//                           <label
//                             className="sub-title"
//                             style={{ fontSize: "16px" }}
//                           >
//                             <a
//                               href="/login"
//                               style={{ marginRight: "6px", fontWeight: "600" }}
//                             >
//                               Login
//                             </a>
//                             or
//                             <a
//                               href="/registration"
//                               style={{ marginLeft: "6px", fontWeight: "600" }}
//                             >
//                               Register
//                             </a>{" "}
//                             to view
//                           </label>
//                         </div>

//                         <div className="block-content">
//                           <div className="product-cats-list">
//                             <Slider {...ProductSettings}>
//                               {products.map((item) => {
//                                 const firstImage = getFirstImage(item.image);

//                                 return (
//                                   <div
//                                     className="item item-product-cat"
//                                     key={item.id}
//                                   >
//                                     <div className="item-product-cat-content">
//                                       <a href="/products">
//                                         <div className="item-image animation-horizontal">
//                                           <img
//                                             style={{ width: "100%", height: "auto" }}
//                                             src={`${Image_URL}UatProduct/${firstImage}`}
//                                             alt={item.productname}
//                                           />
//                                         </div>
//                                       </a>

//                                       <div className="product-cat-content-info">
//                                         <h2 className="item-title">
//                                           <a
//                                             href="#"
//                                             onClick={(e) => {
//                                               e.preventDefault();
//                                               handleProtectedNavigation(
//                                                 "/products",
//                                               );
//                                             }}
//                                           >
//                                             View More
//                                           </a>
//                                         </h2>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 );
//                               })}
//                             </Slider>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </section>

//                 <section className="section section-padding m-b-70">
//                   <div className="section-container large">
//                     {/* Block Banners (Layout 4) */}
//                     <div className="block block-banners layout-4 banners-effect">
//                       <div className="block-widget-wrap">
//                         <div className="row">
//                           <div className="col-md-6 sm-m-b-40">
//                             <div className="block-widget-banner">
//                               <div className="bg-banner">
//                                 <div className="banner-wrapper banners">
//                                   <div className="banner-image">
//                                     <a
//                                       href="#"
//                                       onClick={(e) => {
//                                         e.preventDefault();
//                                         handleProtectedNavigation("/products");
//                                       }}
//                                     >
//                                       <img
//                                         width="690"
//                                         height="398"
//                                         src="../assets/media/banner/banner-4-1.jpg"
//                                         alt="Banner Image"
//                                       />
//                                     </a>
//                                   </div>
//                                   <div className="banner-wrapper-infor">
//                                     <div className="info">
//                                       <div className="content">
//                                         <h3 className="title-banner">
//                                           New Arrivals
//                                         </h3>
//                                         <div className="banner-image-description">
//                                           Elevate your ear party with a choice
//                                           of mix and matched stacks or striking
//                                           solo statements. The choice is yours!
//                                         </div>
//                                         <a
//                                           href="#"
//                                           className="button button-outline border-black"
//                                           onClick={(e) => {
//                                             e.preventDefault();
//                                             handleProtectedNavigation(
//                                               "/products",
//                                             );
//                                           }}
//                                         >
//                                           Login Or Register to view
//                                         </a>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           <div className="col-md-6">
//                             <div className="block-widget-banner">
//                               <div className="bg-banner">
//                                 <div className="banner-wrapper banners">
//                                   <div className="banner-image">
//                                     <a
//                                       href="#"
//                                       onClick={(e) => {
//                                         e.preventDefault();
//                                         handleProtectedNavigation("/products");
//                                       }}
//                                     >
//                                       <img
//                                         width="690"
//                                         height="398"
//                                         src="../assets/media/banner/banner-4-2.jpg"
//                                         alt="Banner Image"
//                                       />
//                                     </a>
//                                   </div>
//                                   <div className="banner-wrapper-infor">
//                                     <div className="info">
//                                       <div className="content">
//                                         <h3 className="title-banner">
//                                           Trending
//                                         </h3>
//                                         <div className="banner-image-description">
//                                           Love to layer? Us too! Transition your
//                                           outfits from day to night in one easy
//                                           step with the power of a unique, luxe
//                                           layered look.
//                                         </div>
//                                         <a
//                                           href="#"
//                                           className="button button-outline border-black"
//                                           onClick={(e) => {
//                                             e.preventDefault();
//                                             handleProtectedNavigation(
//                                               "/products",
//                                             );
//                                           }}
//                                         >
//                                           Login Or Register to view
//                                         </a>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </section>
//               </div>
//             </div>
//           </div>
//         </main>
//         <Footer />
//       </div>
//     </div>
//   );
// };

// export default Index;
